export default "__VITE_ASSET__8bdf31ab__"